<p-confirmDialog [closable]="false" [key]="dialogKey" [baseZIndex]="1000"></p-confirmDialog>
<div *ngIf="isPageReady" class="flex flex-col h-full">
  <div class="qb-content-card flex-1 flex flex-col overflow-hidden">
    <div class="qb-detail-card w-full">
      <div class="flex flex-col gap-3">
        <!-- Row 1: Account + Select Button -->
        <div class="grid grid-cols-10 gap-3">
          <qb-field label="Account" class="col-span-8">
            <input pInputText [ngModel]="addon.account?.accountName" disabled="true" title="Account" />
          </qb-field>
          <div class="col-span-2 flex items-end pb-1">
            <button
              *ngIf="isAdding"
              (click)="selectAccount()"
              pButton
              type="button"
              class="p-button-raised p-button-sm w-full"
              icon="pi pi-search"
            >
              <span>Select</span>
            </button>
          </div>
        </div>

        <!-- Row 2: Name And Location -->
        <div class="grid grid-cols-10 gap-3">
          <qb-field label="Name And Location" class="col-span-10" [forceShowErrors]="showAllErrors">
            <input
              #firstInput
              pInputText
              [(ngModel)]="addon.nameAndLocation"
              [bzModel]="addon"
              name="nameAndLocation"
              title="Name And Location"
            />
          </qb-field>
        </div>

        <!-- Row 3: Image Handler + Checkboxes -->
        <div class="grid grid-cols-10 gap-3">
          <div class="col-span-3">
            <app-image-handler
              [isReadOnly]="!this.authUser.isProductAdmin"
              [oldImages]="addon.addonImages"
              (createJoinEntity)="createImageJoinEntity($event)"
            ></app-image-handler>
          </div>
          <div class="col-span-3 flex items-center gap-2">
            <p-checkbox inputId="isHiddenOnDocs" [(ngModel)]="addon.isHiddenOnDocs" [binary]="true"></p-checkbox>
            <label for="isHiddenOnDocs">Is Hidden on Docs</label>
          </div>
          <div class="col-span-3 flex items-center gap-2">
            <p-checkbox inputId="needsAdditionalInfo" [(ngModel)]="addon.needsAdditionalInfo" [binary]="true"></p-checkbox>
            <label for="needsAdditionalInfo">Needs Additional Info</label>
          </div>
        </div>

        <!-- Row 4: Additional Info Description -->
        <div class="grid grid-cols-10 gap-3">
          <qb-field label="Additional Info Description" class="col-span-10" [forceShowErrors]="showAllErrors">
            <input
              [disabled]="!addon.needsAdditionalInfo"
              [(ngModel)]="addon.additionalInfoDescription"
              [bzModel]="addon"
              name="additionalInfoDescription"
              pInputText
              title="Additional Info Description"
            />
          </qb-field>
        </div>

        <!-- Row 5: Status + Mismatch Feature -->
        <div class="grid grid-cols-10 gap-3">
          <qb-field label="Status" class="col-span-3" [forceShowErrors]="showAllErrors">
            <p-dropdown
              [options]="activeStatuses"
              [(ngModel)]="addon.activeStatusId"
              [bzModel]="addon"
              name="activeStatusId"
              optionValue="id"
              optionLabel="name"
            />
          </qb-field>
          <qb-field label="Mismatch Feature" class="col-span-7">
            <input disabled [ngModel]="addon.mismatchFeature?.name" pInputText title="Mismatch Feature" />
          </qb-field>
        </div>

        <!-- Station Info Section -->
        <p-fieldset legend="Station Info" class="mt-2">
          <!-- Station Row 1: Addon Station + Grouping Key + Document Buttons -->
          <div class="grid grid-cols-12 gap-3">
            <qb-field label="Addon Station" class="col-span-3" [forceShowErrors]="showAllErrors">
              <p-dropdown
                [options]="addonStations"
                [(ngModel)]="addon.addonStationId"
                [bzModel]="addon"
                name="addonStationId"
                optionValue="id"
                optionLabel="name"
                (onChange)="checkGroupingKeyCollision()"
              ></p-dropdown>
            </qb-field>
            <qb-field label="Grouping Key" class="col-span-2" [forceShowErrors]="showAllErrors">
              <input
                [(ngModel)]="addon.groupingKey"
                [bzModel]="addon"
                name="groupingKey"
                pInputText
                title="Grouping Key"
                (blur)="checkGroupingKeyCollision()"
              />
            </qb-field>
            <div class="col-span-7 flex items-start gap-2 mt-8">
              <button (click)="addAddonDoc()" pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-plus">
                <span>Add Document</span>
              </button>
              <button
                [disabled]="addon.addonDocMaps.length == 0"
                (click)="viewAddonDocs()"
                pButton
                type="button"
                class="p-button-raised p-button-sm"
                icon="pi pi-eye"
              >
                <span>View {{ addon.addonDocMaps.length }} Documents</span>
              </button>
            </div>
            <div class="col-span-12 text-xs text-gray-500 leading-snug">
              <b>Grouping Key:</b> Items batch together at a station only when their addons share this tag.
              Auto-filled with a unique value; change it only to deliberately batch with another addon.
            </div>
            <div *ngIf="groupingKeyCollisions?.length" class="col-span-12 text-xs text-amber-700 leading-snug">
              Will batch with: <b>{{ groupingKeyCollisionSummary() }}</b>
            </div>
          </div>

          <!-- Station Row 2: Station Instructions -->
          <div class="grid grid-cols-10 gap-3 mt-3">
            <qb-field label="Station Instructions" class="col-span-10" [forceShowErrors]="showAllErrors">
              <input pInputText [(ngModel)]="addon.instructions" [bzModel]="addon" name="instructions" title="Station Instructions" />
            </qb-field>
          </div>
        </p-fieldset>
      </div>
    </div>
  </div>

  <div class="flex flex-row gap-2 justify-start mt-4">
    <button
      [disabled]="!this.uow.hasChanges()"
      (click)="ok()"
      pButton
      type="button"
      label="Ok"
      title="Ok"
      icon="pi pi-check"
      class="p-button-raised"
    ></button>
    <button (click)="cancel()" pButton type="button" label="Cancel" title="Cancel" icon="pi pi-times" class="p-button-raised"></button>
  </div>
</div>
